import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Paper, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { checkEmailValid } from 'utils/helper';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 0 20px',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  description: {
    maxWidth: '600px',
    fontSize: '18px',
    color: '#888',
    marginBottom: '30px',
  },
  input: {
    width: '100%',
    minWidth: '100px',
    maxWidth: '300px',
    marginBottom: '20px',
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  button: {
    minWidth: '90px',
    fontSize: '16px',
    backgroundColor: '#5b8d8b',
    borderColor: '#5b8d8b',
    borderRadius: '50px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#48706f',
    },
    '&.Mui-disabled': {
      color: '#fff',
      backgroundColor: '#5b8d8b',
      opacity: '0.6',
    },
    '&.cancel': {
      marginLeft: theme.spacing(2),
      backgroundColor: '#A50028',
    },
  },
}));

const ForgotPasswordPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleSubmit = () => {
    if (!checkEmailValid(email)) {
      return setIsValidEmail(false);
    }
    setIsValidEmail(true);

    // TODO
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Paper elevation={0} className={classes.paper}>
            <Typography className={classes.title}>Password Recovery</Typography>
            <Typography className={classes.description}>
              Enter your last name and email address to have your password
              reset. This must be the same email that is used in your account.
            </Typography>
            <TextField
              required
              label='Last Name'
              variant='standard'
              className={classes.input}
              onChange={(e) => setName(e.target.value)}
            ></TextField>
            <TextField
              required
              error={!isValidEmail}
              label='Email'
              variant='standard'
              helperText={isValidEmail ? '' : 'Please enter correct email'}
              className={classes.input}
              onChange={(e) => setEmail(e.target.value)}
            ></TextField>
            <div className={classes.actions}>
              <Button
                variant='contained'
                className={classes.button}
                disabled={!email || !name}
                onClick={handleSubmit}
              >
                Send
              </Button>
              <Button
                variant='contained'
                className={`${classes.button} cancel`}
                onClick={() => navigate('/login')}
              >
                Cancel
              </Button>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </div>
  );
};

export default ForgotPasswordPage;
